
// TODO: Figure out a better way to initialize State based off of a config? - maybe not
import Vue from 'vue'
import {entryEditForShow} from '@/utils/showClassList'
import {editableEntryIndexes, recordEntrySaved, removeEntryFromCard, removeShowFromCard} from '@/utils/entryGrouping'
import {finalizePayload} from '@/utils/preEntries'

const state = {
  currentEntryGroup: {},
  lastEditedEntry: null,
  lastDeletedEntry: null,
  lastAddedEntry: null,
  previousEntryQuestions: {
    camping: null,
    pens: null,
    shavings: null,
    customAnswers: null
  },
  invoice: {}

  /* pens: null,
  camping: null,
  pensPaid: null,
  shavings: null,
  dateEntered: null,
  customAnswers: [],
  entries: {
    'BREEDING': [],
    'MARKET': [],
    'SHOWMANSHIP': []
  },
  payments: {},
  calculatedCost: {} */

}

const mutations = {
  // Entry Group
  setCurrentEntryGroup: (state, payload) => {
    state.currentEntryGroup = payload
  },
  setEntryQuestions: (state, payload) => {
    state.currentEntryGroup.entry_questions = payload
  },
  setPreviousEntryQuestions: (state, payload) => { state.previousEntryQuestions = payload },
  resetToPreviousEntryQuestion: (state) => {
    state.currentEntryGroup.entry_questions = state.previousEntryQuestions
  },
  setLastAddedEntry: (state, entry) => {
    state.lastAddedEntry = entry
  },
  setLastEditedEntry: (state, entry) => {
    state.lastEditedEntry = entry
  },
  setLastDeletedEntry: (state, entry) => {
    state.lastDeletedEntry = entry
  },
  addEntry: (state, payload) => {
    state.currentEntryGroup.entries.push(payload.newEntry)
  },
  updateEntry: (state, payload) => {
    Vue.set(state.currentEntryGroup.entries, payload.index, payload.entry)
  },
  addShowToEntry: (state, payload) => {
    state.currentEntryGroup.entries[payload.index].shows.push(payload.showID)
  },
  addEntryIDToEntry: (state, payload) => {
    state.currentEntryGroup.entries[payload.index].entry_ids.push(payload.entry_id)
  },
  // SHO-439: the show's entry id, number and row go with it, so the card's per-show arrays stay aligned
  removeShowFromEntry: (state, payload) => {
    const card = removeShowFromCard(state.currentEntryGroup.entries[payload.index], payload.showID)
    if (card) Vue.set(state.currentEntryGroup.entries, payload.index, card)
  },
  setEntryIDOnLastAdded: (state, entryIDs) => {
    state.lastAddedEntry.entry_ids = entryIDs
  },
  // The saved animal on the cards holding these entries (a new animal is saved after its entries)
  setAnimalOnEntries: (state, payload) => {
    state.currentEntryGroup.entries.forEach(card => {
      if ((card.entry_ids || []).some(id => payload.entryIDs.indexOf(id) > -1)) {
        Vue.set(card, 'animal_id', payload.animal.animal_id)
        Vue.set(card, 'animal', JSON.parse(JSON.stringify(payload.animal)))
      }
    })
  },
  deleteEntry: (state, payload) => {
    Vue.delete(state.currentEntryGroup.entries, payload.index)
  },
  setInvoice: (state, payload) => {
    state.invoice = payload
  },
  setEntryDate: (state) => {
    state.currentEntryGroup.date_entered = new Date()
  },
  setCheckInComplete: (state, payload) => {
    state.currentEntryGroup.checkin_complete = payload
  },
  addExhibitorList: (state, payload) => {
    // See if exhibitor needs added
    let exhibitorFound = false
    state.currentEntryGroup.exhibitors.forEach(e => {
      if (e.exhibitor_id === payload.exhibitor_id) {
        exhibitorFound = true
      }
    })
    if (!exhibitorFound) {
      state.currentEntryGroup.exhibitors.push({
        exhibitor_id: payload.exhibitor_id,
        first_name: payload.first_name,
        last_name: payload.last_name
      })
    }
  },
  removeExtraExhibitorList: (state) => {
    let deleteIndex = false
    state.currentEntryGroup.exhibitors.forEach((ex, i) => {
      let index = state.currentEntryGroup.entries.findIndex(e => {
        return ex.exhibitor_id === e.exhibitor.exhibitor_id
      })
      if (index < 0) {
        deleteIndex = i
      }
    })
    Vue.delete(state.currentEntryGroup.exhibitors, deleteIndex)
  }
}

const actions = {
  setCurrentEntryGroup: ({commit, dispatch}, payload) => {
    commit('setCurrentEntryGroup', payload)
    dispatch('getInvoiceData', payload)
  },
  // Entry Actions
  createEntryGroup: ({getters, rootState}, payload) => {
    // Check that User is signed in
    if (!rootState.user) {
      return Promise.reject(new Error('You must be logged in before you can create an entry.'))
    } else if (!payload.agreeToRules) {
      // Check that user agreed to rules
      return Promise.reject(new Error('You must agree to show rules before you can create an entry.'))
    } else if (!(new Date(rootState.event.currentEvent.entry_settings.start_online_entries) <= new Date())) {
      return Promise.reject(new Error(`Online entries are not yet open for this event. Please checkback on ${rootState.event.currentEvent.entry_settings.start_online_entries}`))
    } else {
      var entryJSON = JSON.stringify({
        user_id: getters.getUserID,
        event_id: rootState.event.currentEvent.event_id,
        member_pricing: payload.member_pricing
      })
      return rootState.apiInstance.post(`/callFunction/createEntryGroup`, {entryData: entryJSON})
        .then(response => {
          if (!response.data.data) {
            return Promise.reject(new Error(`Online entries are not yet open for this event. Please checkback on ${rootState.event.currentEvent.entry_settings.start_online_entries}`))
          } else {
            // Created Yay
            rootState.apiInstance.get(`/callFunction/checkCredits?event_id=${rootState.event.currentEvent.event_id}`)
          }
        })
    }
  },
  updateEntryGroup: ({rootState, dispatch}, payload) => {
    return rootState.apiInstance.put(`/data/entryGroups/${payload.entry_group_id}`, payload)
      .then(response => {
        if (!response.data.data) {
          return Promise.reject(new Error(`Error updating Entry Group`))
        } else {
          // Created Yay
          dispatch('getInvoiceData', {entry_group_id: payload.entry_group_id})
        }
      })
  },
  createEntry: ({commit, state, getters, rootState, dispatch}, payload) => {
    payload.newEntry.entry_group_id = state.currentEntryGroup.entry_group_id
    payload.newEntry.admin_id = state.currentEntryGroup.admin_id
    payload.newEntry.user_id = getters.getUserID
    payload.newEntry.created_by = getters.getUserID
    payload.newEntry.animal_id = payload.newEntry.animal ? payload.newEntry.animal.animal_id : null

    // SHO-549: pre-entries are built by the server (no animal to save); the group reloads to
    // show their cards
    if (payload.newEntry.pre_entry_count) {
      return rootState.apiInstance.post('/addEntries', payload.newEntry)
        .then(response => dispatch('loadCurrentEvent', {event_slug: rootState.event.currentEvent.event_identifier}).then(() => response))
    }

    var newEntry = JSON.parse(JSON.stringify(payload.newEntry))
    var showList = []
    newEntry.shows.forEach(s => {
      showList.push(s.value)
    })
    newEntry.shows = showList

    commit('addEntry', {newEntry: newEntry})
    commit('setLastAddedEntry', newEntry)

    return rootState.apiInstance.post('/addEntries', payload.newEntry)
      .then(response => {
        dispatch('getInvoiceData', {entry_group_id: state.currentEntryGroup.entry_group_id})
        var entryIDs = []
        response.data.data.forEach(d => {
          entryIDs.push(d.entry_id)
        })
        // same animal in another class: the saved animal keeps its own details
        if (!payload.keepSavedAnimal) {
          dispatch('saveAnimal', {exhibitor_id: payload.newEntry.exhibitor_id, animal: payload.newEntry.animal, entry_ids: entryIDs})
            // a new animal gets its id only now: the card added above needs it to tell when this
            // animal is entered again before the group reloads
            .then(animal => { if (animal && animal.animal_id) commit('setAnimalOnEntries', {entryIDs, animal}) })
            .catch(() => {})
        }
        commit('setEntryIDOnLastAdded', entryIDs)
        commit('addExhibitorList', payload.newEntry.exhibitor)
        return Promise.resolve(response)
      })
      .catch(error => {
        commit('deleteEntry', {index: state.currentEntryGroup.entries.length - 1})
        return Promise.reject(error)
      })
  },
  // SHO-549: a pre-entry's rows get the animal's details and class (POST /finalizePreEntry), then
  // the animal is saved to the exhibitor and the group reloads
  finalizePreEntry: ({rootState, dispatch}, payload) => {
    const entry = payload.entry
    return rootState.apiInstance.post('/finalizePreEntry', finalizePayload(entry))
      .then(response => {
        const entryIDs = response.data.data.map(d => d.entry_id)
        const animalSaved = payload.keepSavedAnimal ? Promise.resolve() : dispatch('saveAnimal', {exhibitor_id: finalizePayload(entry).exhibitor_id, animal: entry.animal, entry_ids: entryIDs})
        return animalSaved
          .catch(() => {})
          .then(() => dispatch('loadCurrentEvent', {event_slug: rootState.event.currentEvent.event_identifier}))
          .then(() => response)
      })
  },
  editEntry: ({commit, state, getters, rootState, dispatch}, payload) => {
    // TODO: Add all Edit Entry Logic To the Database??
    // TODO: Implement optimistic updates in UI so I don't have to rely on full refresh
    var promises = []
    var promisesTypes = []
    var index = state.currentEntryGroup.entries.findIndex(e => e.entry_ids[0] === payload.updateEntry.entry_ids[0])
    commit('setLastEditedEntry', state.currentEntryGroup.entries[index])
    if (payload.type === 'Class' || payload.type === 'Entry Details') {
      const written = []
      // SHO-439: shows already checked in on a card whose shows differ are left as they are
      editableEntryIndexes(payload.updateEntry).forEach(i => {
        const e = payload.updateEntry.entry_ids[i]
        // SHO-409: each entry keeps its own show's class list (class + division per show)
        const perShow = entryEditForShow(payload.updateEntry, i)
        written.push({entry_id: e, saved: {entry_details: perShow.entry_details, class_id: perShow.class_id}})
        promises.push(rootState.apiInstance.put(`/editEntries/${e}`, {
          entry_details: perShow.entry_details,
          class_id: perShow.class_id,
          exhibitor_id: payload.updateEntry.exhibitor.exhibitor_id,
          animal_id: payload.updateEntry.animal ? payload.updateEntry.animal.animal_id : null,
          declaredWeight: payload.declaredWeight,
          allowEditOnly: payload.editOnly,
          // Nomination Settings: informational — the backend keeps only the exhibitor on nominated entries
          exhibitorOnly: !!payload.exhibitorOnly
        }))
      })
      var updatedEntry = JSON.parse(JSON.stringify(payload.updateEntry))
      var showList = []
      updatedEntry.shows.forEach(s => {
        showList.push(s.value)
      })
      updatedEntry.shows = showList
      // the card shown after the edit carries what each entry was saved with (SHO-439)
      written.forEach(w => recordEntrySaved(updatedEntry, w.entry_id, w.saved))

      commit('updateEntry', {index: index, entry: updatedEntry})
    } else if (payload.type === 'Shows') {
      var showsToAdd = []
      // Check if new Show
      payload.updateEntry.shows.forEach(s => {
        if (payload.updateEntry.originalShows.indexOf(s.value) === -1) {
          // Then is a new show
          showsToAdd.push(s)
        }
      })

      if (showsToAdd.length) {
        var newEntry = {
          class_id: payload.updateEntry.class_id,
          // SHO-409: added shows on another class list carry their own class
          class_ids_by_show: payload.updateEntry.class_ids_by_show,
          division_by_show: payload.updateEntry.division_by_show,
          entry_details: payload.updateEntry.entry_details,
          shows: showsToAdd,
          created_by: getters.getUserID,
          user_id: payload.updateEntry.user_id,
          exhibitor_id: payload.updateEntry.exhibitor.exhibitor_id,
          animal_id: payload.updateEntry.animal ? payload.updateEntry.animal.animal_id : null

        }
        // newEntry.user_id = state.currentEntryGroup.user_id
        newEntry.entry_group_id = state.currentEntryGroup.entry_group_id
        newEntry.admin_id = state.currentEntryGroup.admin_id
        newEntry.entry_type = payload.updateEntry.entry_type
        // Don't copy place
        newEntry.entry_details.place = null

        showsToAdd.forEach(s => {
          commit('addShowToEntry', {index: index, showID: s.value})
        })
        promises.push(rootState.apiInstance.post(`/addEntries/`, newEntry))
        promisesTypes.push('add')
      }

      // Check for deleted show
      payload.updateEntry.originalShows.forEach((s, i) => {
        if (!payload.updateEntry.shows.filter(show => { return show.value === s }).length) {
          // Then is a deleted show
          // TODO: Need to update logic to be from backend
          promises.push(rootState.apiInstance.delete(`/data/entries/${payload.updateEntry.entry_ids[i]}`))
          promisesTypes.push('delete')
          commit('removeShowFromEntry', {index: index, showID: s})
        }
      })
    }

    return Promise.all(promises)
      .then(response => {
        response.forEach((r, i) => {
          if (promisesTypes[i] === 'add') {
            r.data.data.forEach(d => {
              // only here: the edit form's entry_ids can be the card's own array (shallow copy), and
              // pushing to both put the id on the card twice (SHO-439 Remove then left a blank show)
              commit('addEntryIDToEntry', {index: index, entry_id: d.entry_id})
            })
          }
        })
        if (payload.updateEntry.animal) {
          dispatch('saveAnimal', {exhibitor_id: payload.updateEntry.exhibitor_id, animal: payload.updateEntry.animal, entry_ids: state.currentEntryGroup.entries[index].entry_ids})
        }
        dispatch('getInvoiceData', {entry_group_id: state.currentEntryGroup.entry_group_id})
        commit('addExhibitorList', payload.updateEntry.exhibitor)
        commit('removeExtraExhibitorList')
      })
      .catch(error => {
        commit('updateEntry', {index: index, entry: state.lastEditedEntry})
        return Promise.reject(error)
      })
  },
  // Resolves with the saved animal once it (and, for a new animal, its entries' animal_id) is saved
  saveAnimal: ({commit, state, getters, rootState, dispatch}, payload) => {
    try {
      if (payload.animal) {
        // Remove excludePoints property from animal before saving
        if (payload.animal.animal_details.excludePoints !== undefined) {
          delete payload.animal.animal_details.excludePoints;
        }
        if (payload.animal.animal_id) {
          // Update Animal Details
          return rootState.apiInstance.put(`/data/animals/${payload.animal.animal_id}`, {animal_details: payload.animal.animal_details})
            .then(() => {
              if (!payload.admin) {
                commit('updateUserAnimalList', payload.animal)
              }
              return payload.animal
            })
        } else {
          // Add Animal
          payload.animal.created_by = getters.getUserID
          // The owner is passed beside the animal and the entry forms don't always copy it
          // onto the animal itself; animals.exhibitor_id is NOT NULL, so without this the
          // insert fails and the entries never get their animal_id. The entry's exhibitor
          // wins: the form's animal can still carry an exhibitor picked before a switch.
          payload.animal.exhibitor_id = payload.exhibitor_id || payload.animal.exhibitor_id
          return rootState.apiInstance.post(`/data/animals/`, payload.animal)
            .then(response => {
              payload.animal.animal_id = response.data.data.animal_id
              const puts = payload.entry_ids.map(e => rootState.apiInstance.put(`data/entries/${e}`, {animal_id: response.data.data.animal_id}))
              if (payload.nomination_id) {
                puts.push(rootState.apiInstance.put(`data/showSeriesAnimalNomination/${payload.nomination_id}`, {animal_id: response.data.data.animal_id}))
              }
              if (!payload.admin) {
                commit('addUserAnimalList', payload.animal)
              }
              return Promise.all(puts).then(() => payload.animal)
            })
        }
      }
    } catch (error) {
    }
    return Promise.resolve(null)
  },
  deleteEntry: ({commit, state, getters, rootState, dispatch}, payload) => {
    var promises = []
    var index = state.currentEntryGroup.entries.findIndex(e => {
      return e.entry_ids.indexOf(payload.entry.entry_ids[0]) > -1
    })

    commit('deleteEntry', {type: payload.entry.entry_type.toLowerCase(), index: index})
    commit('setLastDeletedEntry', payload)

    payload.entry.entry_ids.forEach(e => {
      promises.push(rootState.apiInstance.delete(`/data/entries/${e}`))
    })
    return Promise.all(promises)
      .then(response => {
        dispatch('getInvoiceData', {entry_group_id: state.currentEntryGroup.entry_group_id})
        commit('removeExtraExhibitorList')
      })
      .catch(error => {
        commit('addEntry', {type: payload.entry.entry_type.toLowerCase(), newEntry: state.lastDeletedEntry})
        return Promise.reject(error)
      })
  },
  // SHO-439: take the animal out of one show: delete that show's entry and keep the rest of its card
  deleteShowEntry: ({commit, state, dispatch, rootState}, payload) => {
    return rootState.apiInstance.delete(`/data/entries/${payload.entry_id}`)
      .then(response => {
        const index = state.currentEntryGroup.entries.findIndex(e => (e.entry_ids || []).indexOf(payload.entry_id) > -1)
        if (index > -1) {
          const card = removeEntryFromCard(state.currentEntryGroup.entries[index], payload.entry_id)
          if (card) {
            commit('updateEntry', {index: index, entry: card})
          } else {
            commit('deleteEntry', {index: index})
          }
        }
        dispatch('getInvoiceData', {entry_group_id: state.currentEntryGroup.entry_group_id})
        commit('removeExtraExhibitorList')
      })
  },
  // TODO: Eager loading for these actions
  saveEntryQuestions: ({state, rootState, commit, dispatch}, entryGroup) => {
    let entryQuestions = entryGroup.entry_questions
    commit('setPreviousEntryQuestions', entryQuestions)
    commit('setEntryQuestions', entryQuestions)

    return rootState.apiInstance.put(`/data/entryGroups/${entryGroup.entry_group_id}`, {entry_questions: entryQuestions})
      .then(response => {
        dispatch('getInvoiceData', {entry_group_id: entryGroup.entry_group_id})
      })
      .catch(error => {
        commit('resetToPreviousEntryQuestion')
        dispatch('getInvoiceData', {entry_group_id: entryGroup.entry_group_id})

        return Promise.reject(error)
      })
  },
  getInvoiceData: ({state, rootState, commit}, payload) => {
    if (payload.entry_group_id) {
      return rootState.apiInstance.get(`/invoice?entry_group_id=${payload.entry_group_id}`)
        .then(response => {
          commit('setInvoice', response.data.data)
        })
    }
  },
  enterShow: ({state, rootState, commit, dispatch}, entryGroup) => {
    commit('setEntryDate')
    rootState.apiInstance.put(`/data/entryGroups/${state.currentEntryGroup.entry_group_id}`, {date_entered: new Date()})
      .then(response => {
        dispatch('getInvoiceData', {entry_group_id: state.currentEntryGroup.entry_group_id})
      })
      .catch(error => {
        dispatch('getInvoiceData', {entry_group_id: state.currentEntryGroup.entry_group_id})
        return Promise.reject(error)
      })
  },
  // Commented Out on 4/28
  addExhibitor: ({state, rootState, commit, dispatch, getters}, payload) => {
    // TODO: Remove This conditional
    // May not need this
    let exhibitor = payload.exhibitor
    if (!exhibitor.isAdmin) {
      exhibitor.user_id = getters.getUserID
    }
    return rootState.apiInstance.post('/saveExhibitor', {details: exhibitor, event_id: payload.event_id})
      .then(response => {
        exhibitor.exhibitor_id = response.data.data.exhibitor_id
        if (exhibitor.isAdmin) {
          commit('addToExhibitorList_admin', exhibitor)
        } else {
          commit('addToExhibitorList', exhibitor)
        }
        return Promise.resolve(response.data.data)
        // add user to the list
      })
  },
  updateExhibitor: ({state, rootState, commit, dispatch, getters}, exhibitor) => {
    return rootState.apiInstance.post('/saveExhibitor', {details: exhibitor, event_id: rootState.event.currentEvent.event_id})
      .then(response => {
        if (exhibitor.isAdmin) {
          commit('updateExhibitorInList_admin', exhibitor)
        } else {
          commit('updateExhibitorInList', exhibitor)
        }
        return Promise.resolve(response.data.data)
      })
  }
}

export default {
  namespaced: false,
  state,
  actions,
  mutations
}
